import { render, staticRenderFns } from "./WaiverTask.vue?vue&type=template&id=2af555df&scoped=true"
import script from "./WaiverTask.vue?vue&type=script&lang=ts"
export * from "./WaiverTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af555df",
  null
  
)

export default component.exports